import { Request, BaseApiUrl } from "./api";

// 列表
export const getMatStockListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/MatStock/Get`, { params: params });
};

//新增
export const addMatStock = (params) => {
  return Request.post(`${BaseApiUrl}/api/MatStock/Post`, params);
};

//删除
export const batchDeleteMatStock = (params) => {
  return Request.post(`${BaseApiUrl}/api/MatStock/Delete`, params);
};

//获取详情
export const getMatStockDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/MatStock/Detail`, { params: params });
};
